import { useEffect, useLayoutEffect } from 'react'

// Workaround for this warning:
//
//    Warning: useLayoutEffect does nothing on the server...
//
// Using `useEffect` instead of `useLayoutEffect` on the server makes this error go away.
export const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect
